/* Primary navigation. Screens arrive in build-plan order; entries are added as
   each one ships rather than linking to placeholders. */
export interface NavEntry {
  path: string;
  icon: string;
  label: string;
  /** Exact match only (the home route). */
  end?: boolean;
}

export const NAV: NavEntry[] = [
  { path: '/', icon: 'home', label: 'Today', end: true },
  { path: '/prospecting', icon: 'phone', label: 'Prospecting' },
  { path: '/leads', icon: 'user-plus', label: 'Leads' },
  { path: '/pipeline', icon: 'bar-chart', label: 'Pipeline' },
  { path: '/companies', icon: 'layers', label: 'Companies' },
  { path: '/contacts', icon: 'users', label: 'Contacts' },
  { path: '/phone', icon: 'smartphone', label: 'Phone' },
];
